import script from "./PaymentMethodDefault.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodDefault.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethodDefault.vue?vue&type=style&index=0&id=9d67df7c&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d67df7c"]])

export default __exports__